import { Component, Input, OnInit } from '@angular/core'
import { select, Store } from '@ngrx/store'
import {
  Channel,
  ConfirmDialogService,
  Destroyable,
  selectChannelEntities,
  untilDestroy,
} from '@tokeet-frontend/tv3-platform'
import { DeleteLastMinuteAutomation, LastMinuteAutomation } from '@tokeet-frontend/rate-automations'
import { LastMinuteAutomationDialogService } from '../automation-dialog/last-minute-automation-dialog.service'
@Component({
  selector: 'app-last-minute-automations-grid',
  templateUrl: './last-minute-automations-grid.component.html',
  styleUrls: ['./last-minute-automations-grid.component.scss'],
})
export class LastMinuteAutomationsGridComponent extends Destroyable implements OnInit {
  @Input() items: LastMinuteAutomation[] = []

  channelsById: Record<string, Channel> = {}

  constructor(
    private store: Store<any>,
    private confirmDialog: ConfirmDialogService,
    private lastMinuteAutomationDialog: LastMinuteAutomationDialogService
  ) {
    super()
  }

  ngOnInit(): void {
    this.store.pipe(select(selectChannelEntities), untilDestroy(this)).subscribe((data) => {
      this.channelsById = data
    })
  }

  onEdit(item: LastMinuteAutomation) {
    this.lastMinuteAutomationDialog.open({ lastMinute: item })
  }

  onDelete(item: LastMinuteAutomation) {
    this.confirmDialog
      .confirm({
        title: $localize`Delete this automation?`,
        body: $localize`Are you sure you want to delete this automation?`,
      })
      .subscribe(() => {
        this.store.dispatch(DeleteLastMinuteAutomation({ id: item.key }))
      })
  }
}
